import React, {useEffect, useState, useRef, useContext} from "react";
import './Rulebook.css'


 export const Rulebook = (props) => {
   

    
    return(
      
        <object data="https://narodne-novine.nn.hr/clanci/sluzbeni/dodatni/439893.pdf" type="application/pdf" width="100%" height="700px">
        </object>
 

    );
}
 export default Rulebook;